import styled from "styled-components";

export const StyledRegister = styled.div`
  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2rem 0;
  }

  main {
    background-color: var(--color-gray-3);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 1.5rem 0.5rem 1.5rem;
    margin-bottom: 2rem;
  }

  @media screen and (max-width: 475px) {
    width: 100%;
  }
`;

export const TextSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1rem 0;

  h3 {
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
  }

  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 22px;
    color: var(--color-gray-1);
  }
`;
